import { retrieveLaunchParams } from '@telegram-apps/sdk-react';

import { FallbackUI } from './FallbackUI.tsx';

import { helpers } from '@/helpers.ts';

const APPSTORE_TG_DEEPLINK = helpers.getEnvVar(
  'VITE_APPSTORE_TG_DEEPLINK',
  'https://apps.apple.com/app/telegram-messenger/id686449807'
);
const ANDROID_TG_DEEPLINK = helpers.getEnvVar(
  'VITE_ANDROID_TG_DEEPLINK',
  'https://play.google.com/store/apps/details?id=org.telegram.messenger'
);

export function VersionUnsupported() {
  const { tgWebAppPlatform } = retrieveLaunchParams();

  const handleButtonClick = () => {
    const deepLink =
      tgWebAppPlatform === 'ios' ? APPSTORE_TG_DEEPLINK : ANDROID_TG_DEEPLINK;
    window.open(deepLink, '_blank');
  };

  return (
    <FallbackUI
      buttonTextKey="fallback.update_app"
      messageTextKey="fallback.unsupported_tg_version"
      onButtonClick={handleButtonClick}
    />
  );
}
